import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  loadingScreen: {
    backgroundColor: theme.palette.royal.main,
    color: '#fff',
    position: 'fixed',
    zIndex: '999',
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  linearProgress: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    width: '100%'
  },
  logo: {
    width: '100%',
    maxWidth: 203
  },
  liveEvents: {
    width: '100%',
    maxWidth: 178,
    margin: '70px 0'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/MagicLink/styles.js